import React from "react";
import { connect } from "react-redux";
import { Menu, Icon } from "antd";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { Parse } from "parse";
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");


const MenuMarkup = ({ mobileVersion, activeLinkKey, onLinkClick, firstItem, secondItem, className }) => (

  <Menu
    //theme={mobileVersion ? 'dark' : 'light'}
    mode={mobileVersion ? 'vertical' : 'horizontal'}
    selectedKeys={[`${activeLinkKey}`]}
    type="flex"
    align="center"
    className={className}
  >
    <Menu.Item
      key="0"
      style={{textAlign: "center", fontSize: "16px", marginLeft: 30, marginRight: 30 }}
    >
      <Link onClick={onLinkClick} to="/profile">
        <Icon type="user" />
        Mon profil
      </Link>
    </Menu.Item>
    <Menu.Item
      key="1"
      style={{textAlign: "center", fontSize: "16px", marginLeft: 30, marginRight: 30 }}
    >
      <Link onClick={onLinkClick} to="/agenda">
        <Icon type="calendar" />
        Agenda
      </Link>
    </Menu.Item>
    <Menu.Item
      key="2"
      style={{textAlign: "center", fontSize: "16px", marginLeft: 30, marginRight: 30 }}
    >
      {firstItem}
    </Menu.Item>
    <Menu.Item
      key="3"
      style={{textAlign: "center", fontSize: "16px", marginLeft: 30, marginRight: 30 }}
    >
      <Link onClick={onLinkClick} to="/chat">
        <Icon type="message" />
        Chat
      </Link>
    </Menu.Item>
    <Menu.Item
      key="4"
      style={{ textAlign: "center", fontSize: "16px", marginLeft: 30, marginRight: 30 }}
    >
      <Link onClick={onLinkClick} to="/purchase">
        <Icon type="credit-card" />
        Achat
      </Link>
    </Menu.Item>

    <Menu.Item
      key="5"
      style={{ textAlign: "center", fontSize: "16px", marginLeft: 30, marginRight: 30 }}
    >
      {secondItem}
    </Menu.Item>
  </Menu>
);

MenuMarkup.propTypes = {
  mobileVersion: PropTypes.bool,
  //activeLinkKey: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func,
  className: PropTypes.string,
  //firstItem: PropTypes.func,
  //secondItem: PropTypes.func,
};

MenuMarkup.defaultProps = {
  mobileVersion: false,
  className: 'mobile-navigation',
};


const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    onClickLink: e => {
      dispatch({ type: `CLICKLANDING_${e.key}` });
    },
    handleDisconnect() {
      dispatch({ type: "disconnect" });
    }
  };
};

const connectedMenuMarkup = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuMarkup);
export default connectedMenuMarkup;
